import { ServiceClient } from 'src/utils'
import { FaixaRatingRow, GrupoAnaliseRow, GrupoRow } from './grupo.types'

const serviceClient = ServiceClient.singleton()

export class GrupoService {
    static #INSTANCE = new GrupoService()
    static readonly singleton = () => GrupoService.#INSTANCE

    async fetchGrupoInfo(id: number) {
        return serviceClient.authGet<GrupoRow>(`/api/v1/grupo/${id}`)
    }

    async fetchGrupos() {
        return serviceClient.authGet<GrupoRow[]>(`/api/v1/grupo`)
    }

    async fetchGruposAtivos() {
        return serviceClient.authGet<GrupoRow[]>(`/api/v1/grupo/ativos`)
    }

    async saveGrupo(grupo: GrupoRow) {
        const response = await serviceClient.authPost<GrupoRow>('/api/v1/grupo', grupo)
        return response
    }

    async updateGrupo(idGrupo: number, grupo: GrupoRow) {
        const response = await serviceClient.authPut<GrupoRow>(`/api/v1/grupo/${idGrupo}`, grupo)
        return response
    }

    async saveFaixaRating(idGrupo: number, faixaRating: FaixaRatingRow) {
        const response = await serviceClient.authPost<GrupoRow>(`/api/v1/grupo/${idGrupo}/faixa-rating`, faixaRating)
        return response
    }

    async updateFaixaRating(idGrupo: number, idFaixaRating: number, faixaRating: FaixaRatingRow) {
        const response = await serviceClient.authPut<GrupoRow>(
            `/api/v1/grupo/${idGrupo}/faixa-rating/${idFaixaRating}`,
            faixaRating
        )
        return response
    }

    async removeFaixaRating(idGrupo: number, idFaixaRating: number) {
        const response = await serviceClient.authDelete(`/api/v1/grupo/${idGrupo}/faixa-rating/${idFaixaRating}`)
        return response
    }

    async addGrupoAnalise(grupoId: number, analiseId: number) {
        const response = await serviceClient.authPost<GrupoAnaliseRow>(`/api/v1/grupo/${grupoId}/grupo-analise`, {
            analiseId: analiseId
        })
        return response
    }

    async removeGrupoAnalise(grupoId: number, grupoAnaliseId: number) {
        const response = await serviceClient.authDelete(`/api/v1/grupo/${grupoId}/grupo-analise/${grupoAnaliseId}`)
        return response
    }
}

export default GrupoService.singleton()
